import { render, staticRenderFns } from "./DeleteSubjectModal.vue?vue&type=template&id=b60724d8&"
import script from "./DeleteSubjectModal.vue?vue&type=script&lang=js&"
export * from "./DeleteSubjectModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteSubjectModal.vue?vue&type=style&index=0&id=b60724d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports